export default __webpack_public_path__ + "static/media/bar-charge-time-full.a4e4be43.svg";